export default __webpack_public_path__ + "static/media/D2018_10_30_California.570d9c75.jpg";